import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  basicDetails: {
    code: '',
    name: '',
    description: '',
    status: 'ACTIVE',
    serviceIds: []
  }
};

export const VASAggregateSlice = createSlice({
  name: 'vasAggregate',
  initialState,
  reducers: {
    setBasicDetails: (state, action) => {
      state.basicDetails = action.payload;
    },
    setField: (state, action) => {
      const { field, value } = action.payload;
      state.basicDetails[field] = value;
    },
    setServices: (state, action) => {
      state.basicDetails.serviceIds = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setBasicDetails,
  setField,
  setServices,
  reset,
} = VASAggregateSlice.actions;

export default VASAggregateSlice.reducer;
